import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/serverError";
import { store } from "./store";

export default class CommonStore {
    error: ServerError | null = null;
    token: string | null = window.localStorage.getItem('userJwt');
    appLoaded = false;
    currentUserRole: string | null = window.localStorage.getItem('userrole');

    constructor() {
        makeAutoObservable(this);

        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem('userJwt', token);
                } else {
                    window.localStorage.removeItem('userJwt');
                    store.userStore.logout();
                }
            },
        )

        reaction(
            () => this.currentUserRole,
            currentUserRole => {
                if (currentUserRole) {
                    window.localStorage.setItem('userrole', currentUserRole);
                } else {
                    window.localStorage.removeItem('userrole');
                    store.userStore.logout();
                }
            }
        )
    }

    setServerError = (error: ServerError) => {
        this.error = error;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }

    setCurrentUserRole = (currentUserRole: string | null) => {
        this.currentUserRole = currentUserRole;
    }

    resetAppData = () => {
        store.userStore.user = null;
        window.localStorage.removeItem('userJwt');
        window.localStorage.removeItem('userrole');
        store.adminCollectionStore.resetStoreData();
        store.adminStore.resetAdminStore();
        store.basicUserStore.resetBasicUserStore();
        store.reportingStore.resetStoreData();
    }

}